const changeServiceOrderReportImageUseCase = (repository) => async (link, image) => {
    return await repository(link, image);
}

export default changeServiceOrderReportImageUseCase